import React from 'react';
import { Divider as AntDivider } from 'antd';

const Divider = ({ className }) => {
  return <AntDivider className={className} />;
};

export default Divider;
